import { format, getWeekOfMonth } from 'date-fns';

const conditionallyAddCeroPrefix = (dateValue) => {
  const date = dateValue.toString();
  return date.length === 1 ? `0${date}` : date;
};

export const getUTCDateFromLocaleDay = (localeDate = new Date()) => {
  const year = localeDate.getFullYear().toString();
  const month = conditionallyAddCeroPrefix(localeDate.getMonth() + 1);
  const monthDay = conditionallyAddCeroPrefix(localeDate.getDate());

  return new Date(`${year}-${month}-${monthDay}T00:00:00.000Z`);
};

export const getLocateDateFromUTCDay = (utcDate = new Date()) => {
  const dateSections = utcDate.toISOString().split('-');
  const year = dateSections[0];
  const month = dateSections[1];
  const monthDay = dateSections[2].substring(0, 2);

  return new Date(`${year}-${month}-${monthDay} 00:00:00`);
};

export function formatWeekNumber(date) {
  const weekNumber = getWeekOfMonth(date);
  return format(date, "MMMM - 'WEEK' ").toLocaleUpperCase() + weekNumber;
}
